<template>
    <div class="col_click" :style="styleString" v-if="hasSelectedRange" />
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
import { SHEET_METRICS } from '../../../sheet-state'
import { sheetAxis } from '../../../sheet-axis'
import { sheetFilters } from '../../../sheet-filters'
import { mapGetters } from 'vuex'

export default {
    props: {
        selectedAreaHelper: Object,
        groups: Array
    },
    data() {
        return {
            sheetAxis,
            sheetFilters,
        }
    },
    watch: {
        hasSelectedRange: {
            immediate: true,
            handler: function (newValue) {
                if (newValue == true) {
                    this.addEventListener()
                } else {
                    this.removeEventListener()
                }
            }
        },
        'sheetFilters.groups': {
            deep: true,
            handler: function () {
                this.selectedAreaHelper.clearStartEndPoint()
                this.selectedAreaHelper.clearSelectedRange()
            }
        },
        'sheetFilters.columns': {
            deep: true,
            handler: function () {
                this.selectedAreaHelper.clearStartEndPoint()
                this.selectedAreaHelper.clearSelectedRange()
            }
        },
        'sheetAxis.selectedTimeInterval': {
            deep: true,
            handler: function () {
                this.selectedAreaHelper.clearStartEndPoint()
                this.selectedAreaHelper.clearSelectedRange()
            }
        },
    },
    computed: {
        ...mapGetters(['CellConfig_FindColumnWidth']),
        hasSelectedRange: function () {
            if (this.selectedRange.start.x == undefined || this.selectedRange.end.x == undefined) { return false }
            if (this.selectedRange.start.y == undefined || this.selectedRange.end.y == undefined) { return false }
            // if (this.selectedRange.start.x == this.selectedRange.end.x && this.selectedRange.start.y == this.selectedRange.end.y) { return false }
            return true
        },
        selectedRange: function () {
            let start = deepCopy(this.selectedAreaHelper.selectedRange.start)
            let end = deepCopy(this.selectedAreaHelper.selectedRange.end)
            if (this.selectedAreaHelper.selectedRange.start.x > this.selectedAreaHelper.selectedRange.end.x) {
                start.x = this.selectedAreaHelper.selectedRange.end.x
                end.x = this.selectedAreaHelper.selectedRange.start.x
            }
            if (this.selectedAreaHelper.selectedRange.start.y > this.selectedAreaHelper.selectedRange.end.y) {
                start.y = this.selectedAreaHelper.selectedRange.end.y
                end.y = this.selectedAreaHelper.selectedRange.start.y
            }

            return { start: start, end: end }
        },
        startPoint: function () {
            return this.selectedRange.start
        },
        endPoint: function () {
            return this.selectedRange.end
        },
        top: function () {
            // 스타일 내의 inner, outer 구분에 따른 추가 상수 (+1)
            let targetTime = this.sheetAxis.timeArray[this.startPoint.y]
            let top = targetTime?.topMargin ?? 0
            return SHEET_METRICS.defaultTopMargin + top + 1
        },
        topString: function () {
            return 'top: ' + this.top + 'px; '
        },
        selectedColumns: function () {
            let columns = []
            for (let i = 0; i < this.groups.length; i++) {
                let g = this.groups[i]
                columns = columns.concat(g.columns)
            }
            return columns
        },
        leftColumns: function () {
            return this.selectedColumns.slice(0, this.startPoint.x)
        },
        centerColumns: function () {
            return this.selectedColumns.slice(this.startPoint.x, this.endPoint.x + 1)
        },
        left: function () {
            let hospitalID = this.hospital.selectedHospital._id
            let sum = 0
            for (let i = 0; i < this.leftColumns.length; i++) {
                let c = this.CellConfig_FindColumnWidth(hospitalID, this.leftColumns[i]._id)
                sum += c?.width ?? 160
            }
            return SHEET_METRICS.defaultLeftMargin + sum
        },
        leftString: function () {
            return 'left: ' + this.left + 'px; '
        },
        width: function () {
            // left 상수 추가에 따른 너비 상수 (-1)
            let hospitalID = this.hospital.selectedHospital._id
            let sum = 0
            for (let i = 0; i < this.centerColumns.length; i++) {
                let c = this.CellConfig_FindColumnWidth(hospitalID, this.centerColumns[i]._id)
                sum += c?.width ?? 160
            }
            return (sum) - 1
        },
        widthString: function () {
            return 'width: ' + this.width + 'px; '
        },
        height: function () {
            // 상단 상수 추가에 따른 높이 상수 (-1)
            let start = this.sheetAxis.timeArray[this.startPoint.y]
            let end = this.sheetAxis.timeArray[this.endPoint.y + 1]
            if (end == undefined) { end = this.sheetAxis.timeArray.at(-1) }
            let height = end.topMargin - start.topMargin
            if (this.startPoint.y == this.endPoint.y) {
                height = start.height
            } else {
                if ((this.sheetAxis.timeArray.length - 1) == end.index) {
                    height += end.height
                }
            }
            return height - 1
        },
        heightString: function () {
            return 'height: ' + this.height + 'px; '
        },
        styleString: function () {
            return this.topString + this.leftString + this.widthString + this.heightString
        }
    },
    methods: {
        addEventListener() {
            window.addEventListener('keyup', this.handleKeyUp)
        },
        removeEventListener() {
            window.removeEventListener('keyup', this.handleKeyUp)
        },

        handleKeyUp(e) {
            if (e.keyCode == 27) {
                this.selectedAreaHelper.clearSelectedRange()
            }
        },
    }
}
</script>